export default {
  "b2b.uzivatele-grid.title": "Users"
};
